var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router"}):_vm._e(),_c('router-view',{attrs:{"name":"tabbar"}}),_c('popupLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }